const getRandomNumber = (min = 1, max = 100000) =>
  Math.floor(Math.random() * max) + min;

export default getRandomNumber;
